import { useCallback, useMemo, useState } from 'react';
import { ASSIGNED_USERS_PAGE_SIZE } from '../constants';
import { PermittedUser } from '../types';
import { filterUsers } from '../utils';
import { usePagination } from './usePagination';

export type AssignedUsersList = {
  search: string;
  page: number;
  total: number;
  pageUsers: PermittedUser[];
  onSearch: (value: string) => void;
  onChangePage: (page: number) => void;
};

export const useAssignedUsersList = (users: PermittedUser[]): AssignedUsersList => {
  const [search, setSearch] = useState('');

  const filteredUsers = useMemo(() => filterUsers(users, search), [users, search]);
  const { page, pageItems, onChangePage } = usePagination(filteredUsers, ASSIGNED_USERS_PAGE_SIZE);

  const onSearch = useCallback(
    (value: string) => {
      setSearch(value);
      onChangePage(1);
    },
    [onChangePage],
  );

  return {
    search,
    page,
    total: filteredUsers.length,
    pageUsers: pageItems,
    onSearch,
    onChangePage,
  };
};
